import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { PageHeader } from '@/shared/components/PageHeader';
import { codificado as codifiedRaw } from '@academia-apolo/shared-content';
import { IndexView } from '../components/IndexView';
import { InfractionsView } from '../components/InfractionsView';
const data = codifiedRaw;
export function CodifiedGuidePage() {
    const [tab, setTab] = useState('infractions');
    const [target, setTarget] = useState(null);
    function handleNavigate(norma, article) {
        setTarget((prev) => ({ norma, article, nonce: (prev?.nonce ?? 0) + 1 }));
        setTab('infractions');
    }
    return (_jsxs("div", { children: [_jsx(PageHeader, { title: "Gu\u00EDa codificada", description: data.meta.subtitle }), _jsxs("div", { className: "mb-5 flex gap-1 rounded-lg p-1", style: { background: 'var(--surface)', border: '1px solid var(--border)' }, children: [_jsx(TabButton, { active: tab === 'infractions', onClick: () => setTab('infractions'), children: "Infracciones" }), _jsx(TabButton, { active: tab === 'index', onClick: () => setTab('index'), children: "\u00CDndice de t\u00E9rminos" })] }), tab === 'index' ? (_jsx(IndexView, { data: data, onNavigate: handleNavigate })) : (_jsx(InfractionsView, { data: data, target: target }))] }));
}
function TabButton({ active, onClick, children, }) {
    return (_jsx("button", { type: "button", onClick: onClick, className: "flex-1 rounded-md px-4 py-2 text-sm font-semibold transition-colors", style: {
            background: active ? 'rgba(var(--accent-rgb), 0.15)' : 'transparent',
            color: active ? 'var(--accent)' : 'var(--fg-2)',
        }, children: children }));
}
//# sourceMappingURL=CodifiedGuidePage.js.map